module.exports = __webpack_public_path__ + "static/media/path_Donated.02e09232.svg";